import axios from 'axios';
import store from '@/store';
console.log("🚀 Verificando conexión de Kurdamovil...");
console.log("📡 La URL de la API detectada es:", process.env.VUE_APP_API_URL);
const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true, // si usas cookies o Sanctum
});


// Interceptor para agregar el token automáticamente
api.interceptors.request.use(config => {
  const token = store.state.auth.token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


export default api;